var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 154,
    viewBox: "0 0 150 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.025 12.4837H116.541V0H108.213V12.4837H41.6229V0H33.2952V12.4837H20.8114C9.33357 12.4837 0 21.8173 0 33.2952V133.189C0 144.666 9.33357 154 20.8114 154H129.025C140.503 154 149.836 144.666 149.836 133.189V54.1066V45.7867V33.2952C149.836 21.8251 140.503 12.4837 129.025 12.4837ZM141.516 133.189C141.516 140.074 135.918 145.672 129.033 145.672H20.8114C13.9263 145.672 8.3277 140.074 8.3277 133.189V54.1066H141.516V133.189ZM141.516 45.7867H8.3199V33.2952C8.3199 26.41 13.9185 20.8114 20.8036 20.8114H33.2874V29.1391H41.6229V20.8114H108.221V29.1391H116.549V20.8114H129.033C135.918 20.8114 141.516 26.41 141.516 33.2952V45.7867Z",
    fill: "#D8A5F4",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5894 95.7307H83.237C87.8297 95.7307 91.5647 91.9957 91.5647 87.403V70.7554C91.5647 66.1627 87.8297 62.4277 83.237 62.4277H66.5894C61.9967 62.4277 58.2617 66.1627 58.2617 70.7554V87.403C58.2695 91.9957 62.0045 95.7307 66.5894 95.7307ZM66.5894 70.7554H83.237L83.2448 87.403H66.5894V70.7554Z",
    fill: "#D8A5F4",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.214 95.7307H124.862C129.454 95.7307 133.189 91.9957 133.189 87.403V70.7554C133.189 66.1627 129.454 62.4277 124.862 62.4277H108.214C103.621 62.4277 99.8862 66.1627 99.8862 70.7554V87.403C99.894 91.9957 103.629 95.7307 108.214 95.7307ZM108.214 70.7554H124.862L124.869 87.403H108.214V70.7554Z",
    fill: "#D8A5F4",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9752 137.353H41.6228C46.2155 137.353 49.9505 133.618 49.9505 129.025V112.378C49.9505 107.785 46.2155 104.05 41.6228 104.05H24.9752C20.3824 104.05 16.6475 107.785 16.6475 112.378V129.025C16.6475 133.618 20.3824 137.353 24.9752 137.353ZM24.9752 112.378H41.6228L41.6305 129.025H24.9752V112.378Z",
    fill: "#D8A5F4",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5894 137.353H83.237C87.8297 137.353 91.5647 133.618 91.5647 129.025V112.378C91.5647 107.785 87.8297 104.05 83.237 104.05H66.5894C61.9967 104.05 58.2617 107.785 58.2617 112.378V129.025C58.2695 133.618 62.0045 137.353 66.5894 137.353ZM66.5894 112.378H83.237L83.2448 129.025H66.5894V112.378Z",
    fill: "#D8A5F4",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.214 137.353H124.862C129.454 137.353 133.189 133.618 133.189 129.025V112.378C133.189 107.785 129.454 104.05 124.862 104.05H108.214C103.621 104.05 99.8862 107.785 99.8862 112.378V129.025C99.894 133.618 103.629 137.353 108.214 137.353ZM108.214 112.378H124.862L124.869 129.025H108.214V112.378Z",
    fill: "#D8A5F4",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCalendar);
export default __webpack_public_path__ + "static/media/EmptyCalendar.30904a70c5c661eaafd38a59da772222.svg";
export { ForwardRef as ReactComponent };